<template>
  <v-form v-model="valid" ref="form" lazy-validation v-if="clip_export">
    <v-toolbar :color="$dark() ? 'grey darken-4' : 'deep-orange'" dark>
      <v-toolbar-title>Export MTV compilation</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-layout row wrap style="height: auto;">
        <v-flex xs6 style="padding-bottom: 5px;" pr-1>
          <v-autocomplete
            v-bind:items="mp4_list"
            v-model="clip_export.meta.clip.key"
            label="Video"
            item-text="name"
            item-value="key">
          ></v-autocomplete>
          <v-autocomplete
            v-bind:items="png_list"
            v-model="clip_export.meta.clip.poster_key"
            label="Poster"
            item-text="name"
            item-value="key">
          ></v-autocomplete>
          <component v-for="elem in form.left" :key="elem.name" v-bind:is="elem.type" v-bind="elem" v-model="clip_export.form_data">
            <v-flex :class="row_classes(elem.childs)" v-for="celem in elem.childs" :key="celem.key">
              <component v-bind:is="celem.type" v-bind="celem" v-model="clip_export.form_data"></component>
            </v-flex>
          </component>
        </v-flex>
        <v-flex xs6 style="padding-bottom: 5px;" pl-1>
          <component v-for="elem in form.right" :key="elem.name" v-bind:is="elem.type" v-bind="elem" v-model="clip_export.form_data">
            <v-flex :class="row_classes(elem.childs)" v-for="celem in elem.childs" :key="celem.key">
              <component v-bind:is="celem.type" v-bind="celem" v-model="clip_export.form_data"></component>
            </v-flex>
          </component>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
			<v-btn color="deep-orange" dark @click="export_clip">Export</v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import * as FormItems from '@/components/form_items'

import SettingsModel from '@/models/settings.js'
import ClipModel from '@/models/clip.js'
import EventModel from '@/models/event.js'
import moment from 'moment'
import Vue from 'vue';

export default {
  props: ['event_uuid'],
  components: {
    ...FormItems
  },
  data() {
    var ch = this.$cloudserver.channel("events:clip_export:create");
    return {
      ws_channel: ch,
      clip_export: this.convertClipExport(ch.data),
      valid: false,
      mp4_list: [],
      png_list: []
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.clip_export = this.convertClipExport(newVal, oldVal);
        }
      },
      deep: true
    },
    content_list(newVal) {
      if(_.isEmpty(newVal)) return;
      this.update_items();
    }
  },
  computed: {
    content_list () {
      var list = _.find(Object.values(this.$store.state.cms_lists), (list) => {
        return _.get(list, "meta.system") == true && _.get(list, "meta.system_type") == "cloudrec-import"
      });
      return list.id;
    },
    form () {
      return (this.settings_value.form||{}).fields || [];
    },
    settings () {
      return SettingsModel.get_by_name("mtv_special_export");
    },
    settings_value() {
      return (this.settings||{}).value || {}
    },
    default_value_functions() {
      var self = this;
      return {
        event_start_plus_clip_start (event, clip, info) {
          return event.cached_start_time;
        },
        event_start_plus_clip_end (event, clip, info) {
          return event.cached_start_time;
        },
        from_event(event, clip, info) {
          return _.get(event, info.key, info.default_value);
        }
      }
    }
  },
  methods: {
    update_items() {
      Vue.http.get("content_list/"+this.content_list).then((response) => {
        this.mp4_list = [];
        this.png_list = [];
        _.each(response.body, (item) => {
          if(item.type == "import-mp4") {
            this.mp4_list.push({key: item.key, name: item.key.substr(item.key.lastIndexOf("/") + 1)})
          }
          if(item.type == "import-png") {
            this.png_list.push({key: item.key, name: item.key.substr(item.key.lastIndexOf("/") + 1)})
          }
        });
      }, (response) => {

      });
    },

    export_clip() {
      if (!this.$refs.form.validate()) {
        return;
      }

      var self = this;
      if (typeof(this.ws_channel) != "undefined") {
      	var clip_export = _.cloneDeep(this.clip_export);
        delete clip_export.form_data.__event__;

        var export_configuration_ids = _.get(this.settings, "value.export_configuration_id");

        var save = (export_configuration_id) => {
          return new Promise((resolve, reject) => {
            clip_export.clip_uuids = [];
            clip_export.meta.export_configuration_id = _.get(export_configuration_id, "id", export_configuration_id);
            clip_export.meta.destination = this.settings.name;
            clip_export.event_uuid = this.event_uuid

            clip_export.meta.title = "MTV compilation import";
            if(_.has(export_configuration_id, "name")) {
              clip_export.meta.title += " (" + _.get(export_configuration_id, "name", "") + ")";
            }

            clip_export.meta.mtv_special = true;

            this.ws_channel.save({clip_export: clip_export})
              .then((msg) => {
                resolve(export_configuration_id)
              })
              .catch((msg) => {
                console.log("Unable to export special", msg);

                reject(export_configuration_id)
              });
          });
        }

        if(_.isArray(export_configuration_ids)) {
          Promise.allSettled(_.map(export_configuration_ids, save)).then((results) => {
            _.each(results, (result) => {
              if(result.status == "fulfilled") {
                self.$message.success("Exporting clip ("+_.get(result, "value.name", "")+")!");
              } else {
                self.$message.warning("Unable to export clip ("+_.get(result, "reason.name", "")+")!");
              }
            });

            self.$emit("input", false);
          })
        } else if(_.isNumber(export_configuration_ids)) {
          save(export_configuration_ids).then(() => {
            self.$message.success("Exporting clip!");

            self.$emit("input", false);
          }).catch((result) => {
            console.log("Unable to export MTV special", result)
            self.$message.warning("Unable to export clip!");

            self.$emit("input", false);
          });
        }
      }
    },

    get_event(cb) {
      var channel = this.$cloudserver.channel("events:"+this.event_uuid, false);
      var on_init_ref;
      on_init_ref = channel.on("data", function(msg) {
        channel.off("data", on_init_ref);
        channel.leave();
        if(_.isEmpty(channel.data)) cb(msg.data);
      });
      channel.join();
      if(!_.isEmpty(channel.data)) {
        cb(channel.data);
        channel.off("data", on_init_ref);
        channel.leave();
      }
    },
    convertClipExport (newVal, oldVal) {
			var clip_export = _.cloneDeep(newVal);
			if(typeof(oldVal) != "undefined") {
				//TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
			}

			if(typeof(clip_export) == "undefined" || _.isEmpty(clip_export)) return undefined;

      var form_data = {};
      this.get_event((event) => {
        _.each([].concat(this.form.left,this.form.right), (field) => {
          if(typeof(field.default_value) == "object" && field.default_value.type == "function" && typeof(this.default_value_functions[field.default_value.function]) == "function") {
            form_data[field.name] = this.default_value_functions[field.default_value.function](event, undefined, field.default_value);
          } else if(field.default_value) {
            form_data[field.name] = field.default_value;
          } else {
            if(field.type == "date-time") {
              form_data[field.name] = moment().unix();
            } else if(field.type == "check-box") {
              form_data[field.name] = false;
            } else {
              form_data[field.name] = null;
            }
          }
        });
        form_data.__event__ = event;
        clip_export.form_data = form_data;
      });

      clip_export.meta.clip = {key: "", poster_key: ""}

			return clip_export;
		},
    row_classes(childs) {
      return "xs" + Math.round(12/childs.length);
    }
  },
  created() {
    this.ws_channel.join();
  },
  mounted() {
    this.update_items();
  }
}
</script>
